import { jsx } from "react/jsx-runtime";
import {
  CONTROLLED_DATE_TIME_PICKER_TYPES,
  DSControlledDateTimePicker
} from "@elliemae/ds-form-date-time-picker";
import _ from "lodash";
import { useFormState } from "react-hook-form";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import { Grid } from "@elliemae/ds-grid";
import { useEffect, useState } from "react";
import { format, isValid, parse, parseISO } from "date-fns";
import { useFieldVisibilityAndDisability } from "../utils/fieldVisibilityAndDisability";
import { getDefaultFocusedDate } from "../utils/utils";
const DATE_FORMAT = "MM/dd/yyyy";
const DATE_TIME_FORMAT = "MM/dd/yyyy hh:mm a";
const stripIsoZone = (value) => value.replace(/(T\d{2}:\d{2}(:\d{2}(\.\d+)?)?)(Z|[+-]\d{2}:?\d{2})$/, "$1");
const parsePickerValue = (value, pickerFormat) => {
  if (!value || typeof value !== "string") return "";
  let parsed = parseISO(stripIsoZone(value));
  for (const inputFormat of [
    "MM/dd/yyyy hh:mm:ss a",
    DATE_TIME_FORMAT,
    DATE_FORMAT
  ]) {
    if (isValid(parsed)) break;
    parsed = parse(value, inputFormat, 0);
  }
  return isValid(parsed) ? format(parsed, pickerFormat) : "";
};
const Date = ({
  renderedField,
  schemaForm,
  rules,
  name,
  label,
  required,
  pathValue,
  feedbackMessage,
  ui,
  visible,
  disabled,
  disableCheck,
  visibleCheck,
  preview
}) => {
  const [localDateTimeValue, setLocalDateTimeValue] = useState("");
  const [localDateValue, setLocalDateValue] = useState("");
  const [localTimeValue, setLocalTimeValue] = useState("");
  const { errors } = useFormState({ control: schemaForm.control });
  const errorMessage = _.get(errors, pathValue)?.message;
  const { isVisible, isDisabled } = useFieldVisibilityAndDisability({
    schemaForm,
    rules,
    visible,
    disabled,
    visibleCheck,
    disableCheck,
    preview
  });
  const handleOnDateTimeChange = (newDateTime) => {
    const [prevDate] = localDateTimeValue.split(" ");
    const [newDate, newTime] = newDateTime.split(" ");
    const isDefaultTime = newDate && prevDate !== newDate && !newDate.includes("_") && !newTime.includes("12:00 AM");
    const actualDateTime = isDefaultTime ? `${newDate} 12:00 AM` : newDateTime;
    setLocalDateTimeValue(actualDateTime);
    return actualDateTime;
  };
  const isFullDateTime = ui?.type === CONTROLLED_DATE_TIME_PICKER_TYPES.DATE_TIME.FULL;
  useEffect(() => {
    const pickerValue = parsePickerValue(
      renderedField.value,
      isFullDateTime ? DATE_TIME_FORMAT : DATE_FORMAT
    );
    if (!pickerValue && renderedField.value) return;
    if (isFullDateTime) {
      if (pickerValue !== localDateTimeValue)
        setLocalDateTimeValue(pickerValue);
    } else if (pickerValue !== localDateValue) {
      setLocalDateValue(pickerValue);
    }
  }, [renderedField.value, isFullDateTime]);
  const dateTimeProps = isFullDateTime ? {
    dateTime: localDateTimeValue,
    onDateChange: (newDate) => {
      const strDateTime = `${newDate} ${localTimeValue}`;
      setLocalDateValue(strDateTime);
      renderedField.onChange(strDateTime);
    },
    onTimeChange: (newTime) => {
      const strDateTime = `${localDateValue} ${newTime}`;
      setLocalTimeValue(strDateTime);
      renderedField.onChange(strDateTime);
    },
    onDateTimeChange: (newDateTime) => {
      const actualDateTime = handleOnDateTimeChange(newDateTime);
      renderedField.onChange(actualDateTime);
    }
  } : {
    date: localDateValue,
    onDateChange: (newDate) => {
      const strDateTime = `${newDate}`;
      setLocalDateValue(strDateTime);
      renderedField.onChange(strDateTime);
    }
  };
  return /* @__PURE__ */ jsx(Grid, { span: ui.col_size, style: { display: isVisible ? "block" : "none" }, children: /* @__PURE__ */ jsx(
    DSFormLayoutBlockItem,
    {
      inputID: `epps-field-id-${name}`,
      label,
      required,
      feedbackMessage,
      hasError: !!errorMessage,
      validationMessage: errorMessage,
      children: /* @__PURE__ */ jsx(
        DSControlledDateTimePicker,
        {
          ...renderedField,
          ...dateTimeProps,
          onCalendarOpenFocusedDay: getDefaultFocusedDate(),
          disabled: isDisabled,
          id: pathValue,
          type: ui?.type,
          style: { width: "fit-content" }
        }
      )
    }
  ) });
};
export {
  Date
};
